import { useMutation } from "@tanstack/react-query";

import { processRequest } from "@api/config";
import { otherPrivateAPI } from "@api/outerPrivate";

import { API_PREFIXES } from "@configs/api";

export const useStartSpyModeMutation = () =>
	useMutation({
		mutationFn: async () => {
			await processRequest({
				prefix: API_PREFIXES.START_SPY_MODE,
				request: (token) => otherPrivateAPI.startSpyModeAsync({ token }),
			});
		},
	});

export const useStopSpyModeMutation = () =>
	useMutation({
		mutationFn: async () => {
			await processRequest({
				prefix: API_PREFIXES.STOP_SPY_MODE,
				request: (token) => otherPrivateAPI.stopSpyModeAsync({ token }),
			});
		},
	});
